import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import snu from 'images/snu.svg';
import QuorumBio from '../components/QuorumBio';
import NeoDex from '../components/NeoDex';

export const SponsorDetailPage = () => {
  const { company } = useParams();
  const navigate = useNavigate();

  const getCompany = () => {
    switch (company) {
      case 'quorumbio':
        console.log('quorumbio');
        return <QuorumBio />
      case 'neodex':
        console.log('neo');
        return <NeoDex />
      default:
        console.log("default");
        return null;
    }
  }

  return (
    <div className="SponsorDetailPage">
      {getCompany()}
    </div>
  );
};